// extracted by mini-css-extract-plugin
module.exports = {"actionBox":"PriceFeedbackDialogForm_actionBox__1qQIH","successMessage":"PriceFeedbackDialogForm_successMessage__2qAq5","errorMessage":"PriceFeedbackDialogForm_errorMessage__2WqCW"};